/* eslint-disable prettier/prettier */
// data.js
/* eslint-disable react/prop-types */


// API
import { getPersistedData } from "apis/api";


export default async function persistedMattersDataTable() {


    try {
        const response = await getPersistedData("matters");
        const persistedMattersData = JSON.parse(response.body);


        const persistedMattersRows = persistedMattersData.map((bill) => ({
            ResponsibleAtty: bill?.ResponsibleAtty || "",
            Guaranteed: bill?.Guaranteed || "",
            attorney: bill?.attorney || "",
            OriginatingAtty: bill?.OriginatingAtty || "",
            id: bill?.id || "",
            On_Collection: bill?.["On-Collection"] || "",
            Responsible: bill?.Responsible || "",
            Originating: bill?.Originating || "",
            // client_name: bill?.client?.name || "",
            // client_initials: bill?.client?.initials || "",
            // client_type: bill?.client?.type || "",
            // client_etag: bill?.client?.etag || "",
            // responsible_attorney_id: bill?.responsible_attorney?.id,
            // responsible_attorney_etag: bill?.responsible_attorney?.etag || "",
            // responsible_attorney_name: bill?.responsible_attorney?.name || "",
            // originating_attorney_id: bill?.originating_attorney?.id || 0,
            // originating_attorney_etag: bill?.originating_attorney?.etag || "",
            // originating_attorney_name: bill?.originating_attorney?.name || "",
        }));

        const persistedMattersColumns = [
            { Header: "ResponsibleAtty", accessor: "ResponsibleAtty", align: "center" },
            { Header: "Guaranteed", accessor: "Guaranteed", align: "center" },
            { Header: "attorney", accessor: "attorney", align: "center" },
            { Header: "OriginatingAtty", accessor: "OriginatingAtty", align: "center" },
            { Header: "id", accessor: "id", align: "center" },
            { Header: "On_Collection", accessor: "On_Collection", align: "center" },
            { Header: "Responsible", accessor: "Responsible", align: "center" },
            { Header: "Originating", accessor: "Originating", align: "center" },

        ];

        return { persistedMattersColumns, persistedMattersRows, persistedMattersData };
    } catch (error) {
        console.error("Error in persistedMattersTableData:", error);
        return { persistedMattersRows: [], persistedMattersColumns: [] };
    }
}
